<script>
  import { getTableContext } from "./TableContext.js";

  const tableContext = getTableContext()

  function handleScrollsOnTableHeader(event) {
    if (!(event instanceof WheelEvent) || !$tableContext.funcHorizontalScroll) return

    event.stopPropagation()
    event.preventDefault()
    $tableContext.funcHorizontalScroll(event.deltaY)
  }
</script>

<thead>
  <tr id="head" on:wheel={handleScrollsOnTableHeader}>
    <slot />
  </tr>
</thead>
